<template>
  <div class="w1400 mb50">
    <div class="logo_box flex-box">
      <img src="../../../assets/static/images/jj_logo_new.png" class="c_logo" alt="">
      <div class="fs18 col04 flex-box" v-if="status == 0">退款申请</div>
      <div class="fs18 col04 flex-box" v-if="status == 1">退款/退货申请</div>
    </div>
    <div class="fs14 flex-box col90 ptb10 page_location">
      当前位置：<router-link class="col04" to="/Order">我的订单<span class="plr5">/</span></router-link>
      <div class="now_page">{{ order.status_text }}</div>
    </div>
    <div class="box info_box">
      <div class="fs20 col04 fwb mb15">商品信息</div>
      <div class="title_box flex-box fs18 col04 tc">
        <div class="box1">商品</div>
        <!-- <div class="box2">规格</div> -->
        <div class="box3">单价(元)</div>
        <!-- <div class="box4">优惠</div> -->
        <div class="box5">数量</div>
        <div class="flex-grow-1 tc">小计(元)</div>
      </div>
      <div v-for="(goodsItem, index) in order.items" :key="index" class="goods_box flex-box fs18">
        <div class="box1 flex-box">
          <img :src="goodsItem.goods_image" class="pic" alt="">
          <div class="flex-grow-1 pl30">
            <!-- <span class="fs14 colf">特价</span> -->{{ goodsItem.goods_title }}
          </div>
        </div>
        <!-- <div class="box2 tc">3支/盒</div> -->
        <div class="box3 tc col90">{{ goodsItem.goods_price }}</div>
        <!-- <div class="box4 flex-box flex-center coleb cheap">已降16元</div> -->
        <div class="box5 tc col27">× {{ goodsItem.goods_num }}</div>
        <div v-if="goodsItem" class="flex-grow-1 tc coleb fwb">{{ goodsItem.goods_num * goodsItem.goods_price }}</div>
      </div>
    </div>
    <div class="box reason_box">
      <div class="flex-box col04 mb25">
        <div class="title fs20">退款类型</div>
        <div class="fs18" v-if="status == 0">仅退款</div>
        <div class="fs18" v-if="status == 1">退款/退货</div>
      </div>
      <div class="flex-box col04 mb25">
        <div class="title fs20">退款原因</div>
        <div class="select_box relative">
          <div class="flex-box select fs16 cursor" :class="showReason ? 'active' : ''" @click="showReason = !showReason">
            <div class="flex-grow-1 " :class="formData.reason ? '' : 'col90'">{{ formData.reason ? formData.reason : '请选择'
            }}</div>
          </div>
          <div class="data_list" :class="showReason ? 'show' : ''">
            <div class="item fs18 cursor" v-for="(item, index) in refundReasonList" :key="index"
              @click="refundReasonClick(index)">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="flex-box col04 mb25">
        <div class="title fs20">退款金额</div>
        <div class="fs20 coleb">¥ {{ refundMoney }}</div>
      </div>
      <div class="flex-box col04 mb25" v-if="status == 1">
        <div class="title fs20">货物状态</div>
        <div class="select_box relative">
          <div class="flex-box select fs16 cursor" :class="showReason ? 'active' : ''" @click="showReason = !showReason">
            <div class="flex-grow-1 col90">所属城市</div>
          </div>
          <div class="data_list" :class="showReason ? 'show' : ''">
            <div class="item fs18 cursor" v-for="(item, index) in 30" :key="index" @click="showReason = !showReason">省份1
            </div>
          </div>
        </div>
      </div>
      <div class="flex-box col04 mb25" v-if="status == 1">
        <div class="title fs20">退货数量</div>
        <div class="num_box flex-box ">
          <div class="cursor fs22 minus">-</div>
          <input type="text" class="flex-grow-1 fs22 tc" v-model="refundNum">
          <div class="cursor fs22 plus">+</div>
        </div>
      </div>
      <div class="flex-box flex-col-start col04 mb25">
        <div class="title fs20">退款说明</div>
        <div class="text_pic">
          <textarea v-model="formData.content" maxlength="200" cols="30" rows="10" class="textarea fs18"
            placeholder="请填写申请说明，以助于商家更好的处理售后问题"></textarea>
          <div class="tr num fs14 mb25">{{ formData.content.length }}/200</div>
          <div class="flex-box flex-col-start flex-wrap">
            <div v-for="(img, index) in formData.images" :key="index" class="img_box">
              <img @click="delimg(index)" src="../../../assets/static/icon/c_refund_del.png" class="del" alt="">
              <img :src="img" class="pics" alt="">
            </div>
            <upLoad @upSuc="saveImage" :fileList="fileList">
              <div class="up_box">

              </div>
            </upLoad>
          </div>
        </div>

      </div>
      <div @click="saveStatus ? onSubmit() : ''" :class="saveStatus ? 'can' : ''" class="submit fs20 colf tc ">提交申请</div>
      <!-- <div class="submit fs20 colf tc">提交申请</div> -->
    </div>

  </div>
</template>

<script>
import upLoad from "@/components/Upload.vue";
import {
  useHead
} from '@unhead/vue'
import {
  onMounted
} from "vue"
export default {
  setup() {
    onMounted(() => {
      useHead({
        title: "申请售后-小狮优选",
        meta: [
          { name: "description", content: "This is my page description" },
          { property: "og:title", content: "My Page Title" },
          { property: "og:description", content: "This is my page description" },
          { property: "og:url", content: "https://example.com/my-page" },
          { property: "og:image", content: "https://example.com/my-image.jpg" },
        ],
        link: [{ rel: "canonical", href: "https://example.com/my-page" }],
      })
    })
  },
  components: {
    upLoad
  },
  data() {
    return {
      fileList: [],
      status: 1, //0退款 1退款退货
      showReason: false,
      refundNum: 1,
      orderId: 0,
      itemIds: '',
      order: {
        items: []
      },
      //物流
      expressList: [{
        id: 1,
        name: '已收到货'
      }, {
        id: 2,
        name: '未收到货'
      }],
      expressStatus: false,
      //售后类型
      refundTypeList: [{
        text: '仅退款',
        value: 'refund'
      },
      {
        text: '退/换货',
        value: 'return',
      },
        //{text: '其他',value: 'other',},
      ],
      refundTypeStatus: false,
      //refundTypeIndex: '',

      refundReasonList: [
        // {
        //   value: '1',
        //   title: '卖家发错货了',
        // },
        // {
        //   value: '2',
        //   title: '退运费',
        // },
        // {
        //   value: '3',
        //   title: '大小/重量与商品描述不符',
        // },
        // {
        //   value: '4',
        //   title: '生产日期/保质期与商品描述不符',
        // },
        {
          value: '5',
          title: '质量问题/包装破损',
        },
        // {
        //   value: '6',
        //   title: '我不想要了',
        // },
      ],
      refundReasonStatus: false,
      refundReasonIndex: '',

      refundFrom: 'goods',
      formData: {
        dispatch_text: '',
        dispatch_status: 0,
        type_text: '',
        type: '',
        reason: '',
        content: '',
        images: [],
        goods_num: 1
      },
      refundMoney: 0,
    };
  },
  created() {
    let options = this.$route.query;
    this.status = options.expressIndex;
    this.orderId = options.order_id || 0;
    this.itemIds = options.item_ids || '';
    this.refundFrom = options.refund_from || 'goods';
    this.formData.type = this.refundTypeList[this.status].value;
    this.formData.type_text = this.refundTypeList[this.status].text;
    this.fetchOrderDetail();
  },
  computed: {
    saveStatus() {
      let checkFields = ['type_text', 'reason', 'content'];
      let max_len = checkFields.length,
        len = 0;
      for (let i in this.formData) {
        if (checkFields.indexOf(i) !== -1 && this.formData[i]) {
          len++;
        }
      }
      return len == max_len ? true : false;
    }
  },
  methods: {
    onSubmit() {
      let formData = this.formData;
      let data = {
        ...formData,
        order_id: this.orderId,
        order_item_ids: this.itemIds,
      };
      console.log(data)
      if (!data.type) {
        this.$message('请选择申请类型');
        return;
      }
      if (!data.reason) {
        this.$message('请选择申请原因');
        return;
      }
      if (!data.content) {
        this.$message('请填写申请说明');
        return;
      }
      if (!data.order_id) {
        this.$message('订单错误');
        return;
      }
      if (!data.order_item_ids) {
        this.$message('商品错误');
        return;
      }
      this.$api.Apply(data).then(res => {
        // console.log(res)
        if (res.code == 1) {
          this.$message({
            customClass: 'custom-message',
            message: res.msg,
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.$router.go("-1");
              // this.$router.push({
              // 	path: '/RefundStatus',
              // 	query: {
              // 		id:res.data.id
              // 	}
              // })
            }
          })
        } else {
          this.$message(res.msg);
        }
      })
    },
    delimg(index) {
      this.formData.images.splice(index, 1);
    },
    saveImage(e) {
      console.log('saveImage e = ', e)
      if (this.formData.images.length < 5) {
        this.formData.images.push(e);
      } else {
        this.$message('最多上传5张图片');
      }
      this.fileList = []
    },
    refundReasonClick(index) {
      this.refundReasonIndex = index;
      this.formData.reason = this.refundReasonList[index].title;
      this.showReason = false
    },
    fetchOrderDetail() {
      this.$api.ItemDetail({
        id: this.orderId,
        item_ids: this.itemIds
      }).then(ret => {
        this.order = ret.data;
        if (this.order.status_code == 'nosend') {
            this.refundReasonList = [
              {
                value: '6',
                title: '我不想要了',
              },
              {
                value: '7',
                title: '其他',
              },
            ];
         }
        this.calcPrice();
      })
    },
    calcPrice() {
      let price = 0;
      this.order.items.forEach(goods => {
        if (this.refundFrom == 'goods') {
          price += (goods.goods_price * 10 * this.formData.goods_num);
        } else {
          price += (goods.goods_price * 10 * goods.goods_num);
        }

      })
      this.refundMoney = (price / 10).toFixed(1);
    },
  },
}
</script>

<style lang="less" scoped>
.logo_box {
  height: 150px;

  .c_logo {
    width: 170px;
    display: block;
    margin: 0 60px 0 16px;
  }

  .fs18::before {
        display: block;
        content: "";
        width: 2px;
        height: 100px;
        background: rgba(98, 134, 171, 0.4);
        margin-right: 60px;
    }
}

.page_location {
  margin: 26px 0 24px;
  padding-bottom: 0;
}

.box {
  background: #fff;
}

.info_box {
  padding: 42px 44px 45px;
  margin-bottom: 14px;

  .title_box {
    width: 1312px;
    height: 50px;
    background: #FAFCFF;
  }

  .goods_box {
    height: 192px;
    border-bottom: 1px solid rgba(98, 134, 171, 0.4);
  }

  .box1 {
    width: 473px;

    .pic {
      width: 144px;
      height: 144px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid rgba(98, 134, 171, 0.2);
      margin-left: 44px;
    }

    span {
      width: 43px;
      height: 20px;
      background: linear-gradient(153deg, #FF4D4D 0%, #FF652D 100%);
      border-radius: 5px;
      display: inline-block;
      line-height: 20px;
      text-align: center;
      margin-right: 10px;
    }
  }

  .box2 {
    width: 164px;
  }

  .box3 {
    width: 148px;
  }

  .box4 {
    width: 200px;

    &.cheap::before {
      display: block;
      content: "";
      width: 11px;
      height: 20px;
      background: url('../../../assets/static/icon/c_cheap.png') no-repeat center;
      background-size: 100%;
      margin-right: 7px;
    }
  }

  .box5 {
    width: 200px;
  }
}

.reason_box {
  padding: 48px 216px 44px 44px;

  .title {
    width: 446px;
  }

  .select_box {
    width: 484px;
    height: 53px;
    border-radius: 8px;
    border: 2px solid rgba(98, 134, 171, 0.2);
    padding: 0 19px 0 24px;

    .select {
      height: 46.8px;

      &::after {
        content: "";
        display: block;
        background: url('/src/assets/static/icon/c_arrowd.png') no-repeat center;
        background-size: 100%;
        width: 16px;
        height: 16px;
      }

      &.active::after {
        transform: rotate(180deg);
      }
    }
  }

  .data_list {
    max-height: 300px;
    overflow-y: scroll;
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    background-color: #fff;
    border-radius: 0 0 8px 8px;
    display: none;
    border: 1px solid #CDCDCD;
    z-index: 2;
    border-top: none;

    &.show {
      display: block;
    }

    .item {
      height: 50px;
      line-height: 50px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 0 24px;
      border-top: 1px solid #CDCDCD;

      &:hover {
        background: #1275FF;
        color: #fff;
      }
    }
  }

  .text_pic {
    width: 694px;
    height: 342px;
    background: #F5F9FC;
    border-radius: 12px;
    padding: 25px 20px 20px;

    .textarea {
      width: 100%;
      height: 100px;
      resize: none;
      background: transparent;
      border: none;
      color: #363737;

      &::placeholder {
        color: #ACC0CF !important;
      }
    }

    .num {
      color: #ACC0CF;
    }

    .up_box {
      width: 141px;
      height: 141px;
      position: relative;
      background: url('../../../assets/static/icon/c_refund_up.png') no-repeat center;
      background-size: 100%;

      input {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0;
        opacity: 0;
        cursor: pointer;
      }
    }

    .img_box {
      width: 141px;
      height: 141px;
      position: relative;
      margin-right: 24px;

      .pics {
        width: 141px;
        height: 141px;
        position: relative;
        z-index: 1;
        object-fit: cover;
      }

      .del {
        width: 12px;
        height: 12px;
        position: absolute;
        right: 6px;
        top: 6px;
        display: block;
        z-index: 2;
        cursor: pointer;
      }
    }
  }

  .submit {
    width: 228px;
    height: 66px;
    line-height: 66px;
    background: #ABCEFF;
    border-radius: 6px;
    margin-left: auto;

    &.can {
      background: #1275FF;
    }
  }

  .num_box {
    width: 152px;
    height: 40px;
    border-radius: 8px;
    border: 2px solid rgba(98, 134, 171, 0.2);
    text-align: center;

    .minus,
    .plus {
      height: 36px;
      line-height: 36px;
      width: 40px;
      color: #969696;
    }

    .minus {
      border-right: 2px solid rgba(98, 134, 171, 0.2);
    }

    .plus {
      border-left: 2px solid rgba(98, 134, 171, 0.2);
    }

    input {
      height: 36px;
      color: #969696;
    }
  }
}
</style>
